import useReveal from '../../hooks/useReveal';

/**
 * Fades + lifts its children into place on first scroll into view.
 *
 * @param {string}  as       element to render (default "div")
 * @param {0|1|2|3} delay    stagger step, maps to the .d1/.d2/.d3 CSS delays
 */
export default function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, visible] = useReveal();

  const classes = ['reveal', delay ? `d${delay}` : '', visible ? 'in' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
}
